import React, { useState, useContext, useEffect, Fragment } from "react";
import InputField from "../../../lib/ui/inputs/Input";
import { Accordion, AccordionDetails, AccordionSummary, Button } from "@material-ui/core";
import AdditionalParameters from "./additionalParameters";
import "../../../ui-styles/tooltips/tooltips.css";
import { validateGatewayUrl, validateTemplateId, validateMessageKey } from "../../../lib/validation";
import { createSms, getSmsData, updateSmsData, getTempData, updateTemplate } from "../../../../src/actions/configuration";
import { PayLoadCtx, LangCtx } from "../../../../src/lib/context.js";
import { toast } from "react-toastify";
import Loader from "../../../lib/ui/loader/Loader.js";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AddrDropDown from "../../../lib/ui/dropdown/addressDropDown.js";
import { FaMinusCircle } from "react-icons/fa";

const SMSGateway = () => {
    const [additionalParameters, setAdditionalParameters] = useState(false);
    const [smsTemp, setSmsTemp] = useState(false);
    const [template, setTemplate] = useState([]);
    const [backupTemplates, setBackupTemplates] = useState([]);
    const [error, setError] = useState("");
    const [templateError, setTemplateError] = useState([]);
    const [initialFormData, setInitialFormData] = useState({
        clinicId: "",
        provider: "",
        baseUrl: "",
        path: "",
        method: "POST",
        headers: new Map(),
        senderId: "",
        bodyTemplates: [],
        auth: new Map(),
        ToKey: "",
        messageKey: "",
        FromKey: "",
        FromKeyValue: ""
    });
    const [formData, setFormData] = useState(initialFormData);
    const [smsData, setSmsData] = useState();
    const { l } = useContext(LangCtx);
    const { payload } = useContext(PayLoadCtx);
    const [errorMsg, setErrorMsg] = useState(null);
    const [loading, setLoading] = useState(false);
    const [changeNull, setchangeNull] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [valueMapKeys, setValueMapKeys] = useState([]);
    const [editingIndices, setEditingIndices] = useState([]);

    useEffect(() => {
        setLoading(true);
        Promise.all([getSmsData(payload.userId), getTempData()])
            .then(([smsRes, tempRes]) => {
                console.log("smsRes", smsRes);
                if (smsRes) {
                    setSmsData(smsRes?.data);
                    setSmsTemp(true);
                    const initialData = {
                        baseUrl: smsRes?.data?.baseUrl || "",
                        path: smsRes?.data?.path || "",
                        headers: smsRes?.data?.headers ? Object.entries(smsRes.data.headers).map(([key, value]) => ({ key, value })) : [],
                        ToKey: smsRes?.data?.bodyTemplate?.ToKey || "",
                        FromKey: smsRes?.data?.bodyTemplate?.FromKey || "",
                        FromKeyValue: smsRes?.data?.bodyTemplate?.FromKeyValue || "",
                        messageKey: smsRes?.data?.bodyTemplate?.messageKey || "",
                        method: smsRes?.data?.method || "POST",
                        bodyTemplates: smsRes?.data?.bodyTemplate
                            ? Object.entries(smsRes.data.bodyTemplate).flatMap(([key, value]) => {
                                  if (!["ToKey", "FromKey", "FromKeyValue", "messageKey"].includes(key)) {
                                      return { key, value };
                                  }
                                  return [];
                              })
                            : [],
                    };
                    setFormData(initialData);
                    setInitialFormData(initialData);
                } else {
                    setSmsTemp(false);
                }
                setTemplate(tempRes?.data);
                setBackupTemplates(tempRes?.data);
                const valueMapKeysArray = tempRes?.data?.map((template) => (template.valueMap ? Object.keys(template.valueMap) : []));
                setValueMapKeys(valueMapKeysArray);
                setchangeNull(true);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching data:", err);
                setSmsTemp(false);
                setSmsData();
                setTemplate({});
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        if (changeNull) {
            const updatedTemplates = template.map((template) => {
                if (template.valueMap) {
                    const updatedValueMap = Object.entries(template.valueMap).reduce((acc, [key, value]) => {
                        acc[key] = value === "" ? null : value;
                        return acc;
                    }, {});

                    return {
                        ...template,
                        valueMap: updatedValueMap,
                    };
                }
                return template;
            });
            setTemplate(updatedTemplates);
            setchangeNull(false);
        }
    }, [changeNull]);

    const handleCancel = () => {
        if (initialFormData.baseUrl !== "") {
            setSmsTemp(true);
        }
        setFormData(initialFormData);
        setError("");
    };

    const handleToggle = () => {
        setSmsTemp(false);
    };

    const handleInputChange = (field) => (e) => {
        setFormData({
            ...formData,
            [field]: e.target.value,
        });
        setError({...error, [field]: ""})
    };

    const handleSMS = () => {
        setLoading(true);
        try {
            if (validateForm()) {
                let headers = {};
                let bodyTemplates = {
                    ToKey: formData.ToKey || "",
                    FromKey: formData.FromKey || "",
                    FromKeyValue: formData.FromKeyValue || "",
                    messageKey: formData.messageKey || "",
                };
                formData.bodyTemplates.forEach(({ key, value }) => {
                    if (key && value) {
                        bodyTemplates[key] = value;
                    }
                });
                formData.headers.forEach(({ key, value }) => {
                    if (key && value) {
                        headers[key] = value;
                    }
                });

                let body = {
                    baseUrl: formData.baseUrl,
                    path: formData.path,
                    clinicId: payload.userId,
                    headers: headers,
                    method: formData.method,
                    bodyTemplate: bodyTemplates,
                };

                if (smsData) {
                    updateSmsData(body)
                        .then((res) => {
                            setSmsTemp(true);
                            setLoading(false);
                            toast.success(l.update_sms_details, {
                                position: toast.POSITION.TOP_RIGHT,
                            });
                        })
                        .catch((err) => {
                            console.error(err);
                            setSmsTemp(false);
                            setLoading(false);
                            toast.error(err.response?.data?.error);
                        });
                } else {
                    createSms(body)
                        .then((res) => {
                            setSmsTemp(true);
                            setLoading(false);
                            toast.success(l.create_sms_details, {
                                position: toast.POSITION.TOP_RIGHT,
                            });
                        })
                        .catch((err) => {
                            console.error("Error:", err);
                            setSmsTemp(false);
                            setLoading(false);
                            toast.error(err.response?.data?.error);
                        });
                }
            } else {
                setLoading(false);
                if (errorMsg !== null) {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                }
            }
        } catch (err) {
            setLoading(false);
            toast.error(err.errorMessage, {
                position: toast.POSITION.TOP_RIGHT,
            });
            console.log("Error", err);
            setErrorMsg("Something went wrong, please try again later");
        }
    };

    const handleClose = () => {
        setAdditionalParameters(false);
    };

    const addItem = (type) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [type]: [...(prevFormData[type] || []), { key: "", value: "" }],
        }));
    };

    const updateItemKey = (type, index, newKey) => {
        setFormData((prevFormData) => {
            const items = prevFormData[type] ? [...prevFormData[type]] : [{ key: "", value: "" }];
            items[index] = { ...items[index], key: newKey };
            return { ...prevFormData, [type]: items };
        });
    };

    const updateItemValue = (type, index, newValue) => {
        setFormData((prevFormData) => {
            const items = prevFormData[type] ? [...prevFormData[type]] : [{ key: "", value: "" }];
            items[index] = { ...items[index], value: newValue };
            return { ...prevFormData, [type]: items };
        });
    };

    const removeItem = (type, index) => {
        setFormData((prevFormData) => {
            const updatedItems = prevFormData[type].filter((_, i) => i !== index);
            return { ...prevFormData, [type]: updatedItems };
        });
    };

    const updateStaticBodyTemplateField = (field, value) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [field]: value,
        }));
    };

    const validateTemplate = (updatedBody, index) => {
        let _error = {};
        let returnValue = true;
        if (updatedBody.templateId === "" || updatedBody.templateId === null) {
            _error["templateId"] = "Please enter a Template Id";
            returnValue = false;
        } else if (!validateTemplateId(updatedBody.templateId)) {
            _error["templateId"] = "Please enter a valid Template Id";
            returnValue = false;
        }
        if (updatedBody.templateBody === "" || updatedBody.templateBody === null) {
            _error["templateBody"] = "Please enter a Template Body";
            returnValue = false;
        }
        console.log("error in creare sms data-----", _error, returnValue);
        setTemplateError((prevErrors) => {
            const newErrors = [...prevErrors];
            newErrors[index] = _error;
            return newErrors;
        });
        return returnValue;
    };

    const validateForm = () => {
        let _error = {};
        let returnValue = true;
        if (formData.baseUrl === "" || formData.baseUrl === null) {
            _error["baseUrl"] = "Please enter a base url";
            returnValue = false;
        } else if (!validateGatewayUrl(formData.baseUrl)) {
            _error["baseUrl"] = "Please enter a valid base url";
            returnValue = false;
        }
        if (formData.messageKey === "" || formData.messageKey === null) {
            _error["messageKey"] = "Please enter a message key";
            returnValue = false;
        } else if (!validateMessageKey(formData.messageKey)) {
            _error["messagekey"] = "Please enter a valid message key";
            returnValue = false;
        }
        if (formData.path === "" || formData.path === null) {
            _error["path"] = "Please enter a gateway path";
            returnValue = false;
        }
        if (formData.ToKey === "" || formData.ToKey === null) {
            _error["ToKey"] = "Please enter a ToKey";
            returnValue = false;
        }
        if (formData.FromKey === "" || formData.FromKey === null) {
            _error["FromKey"] = "Please enter a FromKey";
            returnValue = false;
        }
        if (formData.FromKeyValue === "" || formData.FromKeyValue === null) {
            _error["FromKeyValue"] = "Please enter a FromKeyValue";
            returnValue = false;
        }
        _error["headers"] = [];
        _error["bodyTemplates"] = [];

        if (formData.headers.length > 0) {
            formData.headers.forEach(({ key, value }, index) => {
                if (key === "" || !value || value === "") {
                    _error["headers"][index] = "Please enter valid header key and value ";
                    returnValue = false;
                } else {
                    _error["headers"][index] = null;
                }
            });
        } else {
            _error["headers"][0] = "Please enter valid header key and value ";
        }
        formData.bodyTemplates.forEach(({ key, value }, index) => {
            if (key === "" || !value || value === "") {
                _error["bodyTemplates"][index] = "Please enter valid key and value ";
                returnValue = false;
            } else {
                _error["bodyTemplates"][index] = null;
            }
        });
        console.log("error in creare sms data-----", _error, returnValue);
        setError(_error);
        return returnValue;
    };

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleEditToggle = (index) => {
        setEditingIndices((prevIndices) => {
            if (prevIndices.includes(index)) {
                return prevIndices.filter((i) => i !== index);
            } else {
                return [...prevIndices, index];
            }
        });
    };

    const updateTemplateField = (index, field, value) => {
        setTemplate((prevTemplates) => prevTemplates.map((template, idx) => (idx === index ? { ...template, [field]: value } : template)));
    };

    const updateValueMapKey = (templateIndex, oldKey, newKey) => {
        setTemplate((prevTemplates) => {
            const updatedTemplates = [...prevTemplates];
            const updatedValueMap = { ...updatedTemplates[templateIndex].valueMap };
            if (newKey && !updatedValueMap[newKey]) {
                updatedValueMap[newKey] = updatedValueMap[oldKey];
                updatedValueMap[oldKey] = null;
            }

            updatedTemplates[templateIndex] = {
                ...updatedTemplates[templateIndex],
                valueMap: updatedValueMap,
            };
            return updatedTemplates;
        });
    };

    const updateValueMapValue = (templateIndex, key, value) => {
        setTemplate((prevTemplates) => {
            const updatedTemplates = [...prevTemplates];
            const updatedValueMap = {
                ...updatedTemplates[templateIndex].valueMap,
                [key]: value,
            };
            updatedTemplates[templateIndex] = {
                ...updatedTemplates[templateIndex],
                valueMap: updatedValueMap,
            };
            return updatedTemplates;
        });
    };

    const addValueMapEntry = (templateIndex) => {
        setTemplate((prevTemplates) => {
            const updatedTemplates = [...prevTemplates];
            const availableKeys = valueMapKeys[templateIndex].filter(
                (key) => !(key in updatedTemplates[templateIndex].valueMap) || updatedTemplates[templateIndex].valueMap[key] === null
            );
            const newKey = availableKeys[0];

            if (newKey) {
                if (updatedTemplates[templateIndex].valueMap[newKey] === null) {
                    delete updatedTemplates[templateIndex].valueMap[newKey];
                }
                updatedTemplates[templateIndex] = {
                    ...updatedTemplates[templateIndex],
                    valueMap: {
                        ...updatedTemplates[templateIndex].valueMap,
                        [newKey]: "",
                    },
                };
            }
            return updatedTemplates;
        });
    };

    const removeValueMapEntry = (templateIndex, key) => {
        setTemplate((prevTemplates) => {
            const updatedTemplates = [...prevTemplates];
            const updatedValueMap = { ...updatedTemplates[templateIndex].valueMap };
            updatedValueMap[key] = null;
            updatedTemplates[templateIndex] = {
                ...updatedTemplates[templateIndex],
                valueMap: updatedValueMap,
            };
            return updatedTemplates;
        });
    };

    const resetTemplate = (index) => {
        setTemplate((prevTemplates) =>
            prevTemplates.map((template, idx) => {
                if (idx === index) {
                    const backupTemplate = backupTemplates[index];
                    const updatedValueMap = backupTemplate.valueMap
                        ? Object.entries(backupTemplate.valueMap).reduce((acc, [key, value]) => {
                              acc[key] = value === "" ? null : value;
                              return acc;
                          }, {})
                        : null;

                    return {
                        ...backupTemplate,
                        valueMap: updatedValueMap,
                    };
                }
                return template;
            })
        );
        setTemplateError((prevErrors) => {
            const newErrors = [...prevErrors];
            newErrors[index] = {};
            return newErrors;
        });
        setEditingIndices((prevIndices) => prevIndices.filter((i) => i !== index));
    };

    const saveTemplate = (body, index) => {
        setLoading(true);
        const updatedBody = { ...body };
        delete updatedBody._id;
        updatedBody.valueMap = updatedBody.valueMap
            ? Object.entries(updatedBody.valueMap).reduce((acc, [key, value]) => {
                  acc[key] = value === null ? "" : value;
                  return acc;
              }, {})
            : null;
        if (validateTemplate(updatedBody, index)) {
            updateTemplate(updatedBody, updatedBody.templateTitle)
                .then((res) => {
                    setBackupTemplates((prevBackup) => prevBackup.map((temp, idx) => (idx === index ? updatedBody : temp)));
                    setchangeNull(true);
                    setEditingIndices((prevIndices) => prevIndices.filter((i) => i !== index));
                    setLoading(false);
                    toast.success(l.update_template_details, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                })
                .catch((err) => {
                    console.error("Error:", err);
                    toast.error(err.response?.data?.error);
                    setLoading(false);
                });
        } else {
            setLoading(false);
            if (errorMsg !== null) {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }
        }
    };

    return loading ? (
        <Loader />
    ) : (
        <Fragment>
            <div className="resColRowSms nopdng">
                <div className=" pdngMD width50">
                    <form onSubmit={handleSMS}>
                        <small className="inpLabel">
                            {l.base_url}
                            <span className="redTxt">*</span>:
                        </small>
                        <div className={`inputRowFeild ${smsTemp ? "disabledStripeInput" : ""}`}>
                            <InputField
                                placeholder={l.enter_base_url}
                                type="text"
                                onChange={handleInputChange("baseUrl")}
                                value={formData?.baseUrl}
                                error={error && error?.baseUrl}
                                errorMsg={error?.baseUrl}
                                disabled={smsTemp}
                            />
                        </div>

                        <small className="inpLabel">
                            {l.path}
                            <span className="redTxt">*</span>:
                        </small>
                        <div className={`inputRowFeild ${smsTemp ? "disabledStripeInput" : ""}`}>
                            <InputField
                                placeholder={l.enter_path}
                                type="text"
                                onChange={handleInputChange("path")}
                                value={formData?.path}
                                error={error && error?.path}
                                errorMsg={error?.path}
                                disabled={smsTemp}
                            />
                        </div>
                        <small className="inpLabel">
                            {l.headers}
                            <span className="redTxt">*</span>:
                        </small>
                        <div className="inputRowFeild">
                            {(formData.headers.length > 0 ? formData.headers : [{}]).map(({ key, value }, index) => (
                                <>
                                    <div className="flexRow alignCenter pdngTXS" key={index}>
                                        <div style={{ width: "50%" }} className={`pdngRSM ${smsTemp ? "disabledStripeInput" : ""}`}>
                                            <InputField
                                                placeholder={l.enter_header_key}
                                                type="text"
                                                value={key || ""}
                                                className="inputField"
                                                disabled={smsTemp}
                                                onChange={(e) => updateItemKey("headers", index, e.target.value)}
                                            />
                                        </div>
                                        <div className={`flexMinWidthRow ${smsTemp ? "disabledStripeInput" : ""}`}>
                                            <InputField
                                                placeholder={l.enter_header_value}
                                                type="text"
                                                value={value || ""}
                                                className="inputField"
                                                disabled={smsTemp}
                                                onChange={(e) => updateItemValue("headers", index, e.target.value)}
                                            />
                                        </div>
                                        {!smsTemp && formData.headers.length > 1 && (
                                            <div className="flexAuto pdngLSM">
                                                <FaMinusCircle
                                                    style={{ color: "#24A4C4", fontSize: "20px", cursor: "pointer" }}
                                                    onClick={() => removeItem("headers", index)}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    {error?.headers && error?.headers[index] && (
                                        <span style={{ color: "red", fontSize: "12px" }}>{error?.headers[index]}</span>
                                    )}
                                </>
                            ))}
                            {!smsTemp && (
                                <div className="flexRow justfiyEnd alignEnd pdngTXS">
                                    <span className="pointer copytext font14 primaryTxt" onClick={() => addItem("headers")}>
                                        + {l.plus}
                                    </span>
                                </div>
                            )}
                        </div>

                        <small className="inpLabel">
                            {l.method}
                            <span className="redTxt">*</span>:
                        </small>
                        <div>
                            <AddrDropDown
                                className={`fullWidth ${smsTemp ? "disabledStripeInput" : ""}`}
                                items={[
                                    { value: "POST", label: "POST" },
                                    { value: "PUT", label: "PUT" },
                                    { value: "GET", label: "GET" },
                                ]}
                                value={formData.method}
                                onChange={handleInputChange("method")}
                                disabled={smsTemp}
                            />
                        </div>
                        <small className="inpLabel">
                            {l.body_template}
                            <span className="redTxt">*</span>:
                        </small>
                        <div className={`inputRowFeild`}>
                            <div className="flexRow">
                                <div style={{ width: "50%" }} className="pdngRSM disabledStripeInput">
                                    <InputField
                                        value={l.to_key}
                                        type="text"
                                        disabled="true"
                                        error={error && error?.ToKey}
                                        errorMsg={error?.ToKey}
                                    />
                                </div>
                                <div style={{ width: "50%" }} className={`inputRowFeild ${smsTemp ? "disabledStripeInput" : ""}`}>
                                    <InputField
                                        placeholder={l.enter_to_key}
                                        value={formData.ToKey || ""}
                                        type="text"
                                        onChange={(e) => updateStaticBodyTemplateField("ToKey", e.target.value)}
                                        disabled={smsTemp}
                                    />
                                </div>
                            </div>
                            <div className="flexRow">
                                <div style={{ width: "50%" }} className="pdngRSM disabledStripeInput">
                                    <InputField
                                        value={l.from_key}
                                        type="text"
                                        disabled="true"
                                        error={error && error?.FromKey}
                                        errorMsg={error?.FromKey}
                                    />
                                </div>
                                <div style={{ width: "50%" }} className={`inputRowFeild ${smsTemp ? "disabledStripeInput" : ""}`}>
                                    <InputField
                                        placeholder={l.enter_from_key}
                                        value={formData.FromKey || ""}
                                        type="text"
                                        onChange={(e) => updateStaticBodyTemplateField("FromKey", e.target.value)}
                                        disabled={smsTemp}
                                    />
                                </div>
                            </div>
                            <div className="flexRow">
                                <div style={{ width: "50%" }} className="pdngRSM disabledStripeInput">
                                    <InputField
                                        value={l.message_key}
                                        type="text"
                                        disabled="true"
                                        error={error && error?.messageKey}
                                        errorMsg={error?.messageKey}
                                    />
                                </div>
                                <div style={{ width: "50%" }} className={`inputRowFeild ${smsTemp ? "disabledStripeInput" : ""}`}>
                                    <InputField
                                        placeholder={l.enter_messageKey}
                                        value={formData.messageKey || ""}
                                        type="text"
                                        onChange={(e) => updateStaticBodyTemplateField("messageKey", e.target.value)}
                                        disabled={smsTemp}
                                    />
                                </div>
                            </div>
                            <div className="flexRow">
                                <div style={{ width: "50%" }} className="pdngRSM disabledStripeInput">
                                    <InputField
                                        value={l.fromKey_value}
                                        type="text"
                                        disabled="true"
                                        error={error && error?.FromKeyValue}
                                        errorMsg={error?.FromKeyValue}
                                    />
                                </div>
                                <div style={{ width: "50%" }} className={`inputRowFeild ${smsTemp ? "disabledStripeInput" : ""}`}>
                                    <InputField
                                        placeholder={l.enter_fromKey_value}
                                        value={formData.FromKeyValue || ""}
                                        type="text"
                                        onChange={(e) => updateStaticBodyTemplateField("FromKeyValue", e.target.value)}
                                        disabled={smsTemp}
                                    />
                                </div>
                            </div>
                            <div className="inputRowFeild">
                                {formData.bodyTemplates.length > 0 &&
                                    formData.bodyTemplates.map(({ key, value }, index) => (
                                        <>
                                            <div className="flexRow alignCenter pdngTXS" key={index}>
                                                <div style={{ width: "50%" }} className={`pdngRSM ${smsTemp ? "disabledStripeInput" : ""}`}>
                                                    <InputField
                                                        placeholder={l.enter_key}
                                                        type="text"
                                                        value={key || ""}
                                                        className="inputField"
                                                        disabled={smsTemp}
                                                        onChange={(e) => updateItemKey("bodyTemplates", index, e.target.value)}
                                                    />
                                                </div>
                                                <div className={`flexMinWidthRow ${smsTemp ? "disabledStripeInput" : ""}`}>
                                                    <InputField
                                                        placeholder={l.enter_value}
                                                        type="text"
                                                        value={value || ""}
                                                        className="inputField"
                                                        disabled={smsTemp}
                                                        onChange={(e) => updateItemValue("bodyTemplates", index, e.target.value)}
                                                    />
                                                </div>
                                                {!smsTemp && formData.bodyTemplates.length > 0 && (
                                                    <div className="flexAuto pdngLSM">
                                                        <FaMinusCircle
                                                            style={{ color: "#24A4C4", fontSize: "20px", cursor: "pointer" }}
                                                            onClick={() => removeItem("bodyTemplates", index)}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                            {error?.bodyTemplates && error?.bodyTemplates[index] && (
                                                <span style={{ color: "red", fontSize: "12px" }}>{error?.bodyTemplates[index]}</span>
                                            )}
                                        </>
                                    ))}

                                {!smsTemp && (
                                    <div className="flexRow justfiyEnd alignEnd pdngTXS">
                                        <span className="pointer copytext font14 primaryTxt" onClick={() => addItem("bodyTemplates")}>
                                            + {l.plus}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="crdBtnContainer justfiyEnd">
                            {!smsTemp && (
                                <div className="flexInline pdngHSM capitalTxt">
                                    <Button variant="outlined" color="primary" className="capitalTxt" onClick={handleCancel}>
                                        {l.cancel}
                                    </Button>
                                </div>
                            )}
                            {smsTemp ? (
                                <Button variant="contained" color="primary" className="whiteTxt capitalTxt" onClick={handleToggle}>
                                    {l.edit}
                                </Button>
                            ) : (
                                <Button variant="contained" color="primary" className="whiteTxt capitalTxt" onClick={handleSMS}>
                                    {l.save}
                                </Button>
                            )}
                        </div>
                    </form>
                </div>
                {template.length > 0 && (
                    <div className="pdngMD width50">
                        <div className="flexCol marg">
                            <span className="pdngHXSM pdngBSX font18 copytext">Templates</span>
                            <div className="flexCol">
                                {template.map((item, index) => (
                                    <div className="flexCol pdngXS" key={index}>
                                        <Accordion
                                            expanded={expanded === `panel${index}`}
                                            onChange={handleChange(`panel${index}`)}
                                            className="custom-accordion"
                                            style={{
                                                backgroundColor: "#23A4C41A",
                                                borderRadius: "13px",
                                                boxShadow: "none",
                                                borderTop: "none",
                                            }}
                                        >
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls={`panel${index}a-content`}
                                                id={`panel${index}a-header`}
                                                className="pdngHSM fullWidth"
                                                // style={{
                                                //     minHeight: expanded === `panel${index}` ? "64px" : "48px",
                                                // }}
                                            >
                                                <span className="font14 copytext pdngBSX">{item.templateTitle}</span>
                                            </AccordionSummary>
                                            <AccordionDetails style={{ padding: 0 }}>
                                                <div className="pdngMD flexCol">
                                                    <div
                                                        className={`pdngBSX fullWidth ${
                                                            !editingIndices.includes(index) ? "disabledStripeInput" : ""
                                                        }`}
                                                    >
                                                        <textarea
                                                            className="fullWidth"
                                                            style={{
                                                                borderRadius: "13px",
                                                                padding: "5px",
                                                                outline: "none",
                                                                border: "1px solid rgba(0, 0, 0, 0.24)",
                                                                boxShadow: "none",
                                                            }}
                                                            placeholder={l.enter_template_body}
                                                            rows="5"
                                                            value={item.templateBody ? item.templateBody : ""}
                                                            onChange={(e) => updateTemplateField(index, "templateBody", e.target.value)}
                                                            disabled={!editingIndices.includes(index)}
                                                        />
                                                        {templateError[index]?.templateBody && (
                                                            <span style={{ color: "red", fontSize: "12px" }}>
                                                                {templateError[index]?.templateBody}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div
                                                        className={`inputRowFeild ${
                                                            !editingIndices.includes(index) ? "disabledStripeInput" : ""
                                                        }`}
                                                    >
                                                        <InputField
                                                            placeholder={l.enter_template_id}
                                                            value={item.templateId}
                                                            type="text"
                                                            disabled={!editingIndices.includes(index)}
                                                            onChange={(e) => updateTemplateField(index, "templateId", e.target.value)}
                                                            error={templateError[index]?.templateId}
                                                            errorMsg={templateError[index]?.templateId}
                                                        />
                                                    </div>
                                                    {item.valueMap &&
                                                        Object.entries(item.valueMap).map(
                                                            ([key, value]) =>
                                                                value !== null && (
                                                                    <div
                                                                        key={key}
                                                                        style={{ display: "flex", alignItems: "center", padding: "6px 0" }}
                                                                    >
                                                                        <div
                                                                            className={`flexMinWidthRow fullWidth pdngRSM ${
                                                                                !editingIndices.includes(index) ? "disabledStripeInput" : ""
                                                                            }`}
                                                                        >
                                                                            <AddrDropDown
                                                                                size="fullWidth"
                                                                                items={
                                                                                    valueMapKeys[index]?.map((k) => ({
                                                                                        value: k,
                                                                                        label: k,
                                                                                    })) || []
                                                                                }
                                                                                value={key}
                                                                                onChange={(e) =>
                                                                                    updateValueMapKey(index, key, e.target.value)
                                                                                }
                                                                                disabled={!editingIndices.includes(index)}
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            className={`flexMinWidthRow ${
                                                                                !editingIndices.includes(index) ? "disabledStripeInput" : ""
                                                                            }`}
                                                                        >
                                                                            <InputField
                                                                                type="text"
                                                                                placeholder={l.enter_value}
                                                                                value={value}
                                                                                onChange={(e) =>
                                                                                    updateValueMapValue(index, key, e.target.value)
                                                                                }
                                                                                disabled={!editingIndices.includes(index)}
                                                                            />
                                                                        </div>
                                                                        {editingIndices.includes(index) && (
                                                                            <div className="pdngLSM">
                                                                                <FaMinusCircle
                                                                                    onClick={() => removeValueMapEntry(index, key)}
                                                                                    style={{
                                                                                        cursor: "pointer",
                                                                                        fontSize: "18px",
                                                                                        color: "#24A4C4",
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )
                                                        )}
                                                    {editingIndices.includes(index) &&
                                                        item.valueMap &&
                                                        Object.keys(item.valueMap).some((key) => item.valueMap[key] === null) && (
                                                            <div className="flexRow justfiyEnd pdngTXS">
                                                                <span
                                                                    className="pointer copytext font14 primaryTxt"
                                                                    onClick={() => addValueMapEntry(index)}
                                                                >
                                                                    + {l.plus}
                                                                </span>
                                                            </div>
                                                        )}
                                                    <div className="crdBtnContainer justfiyEnd">
                                                        {editingIndices.includes(index) && (
                                                            <div className="flexInline pdngHSM capitalTxt">
                                                                <Button
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    onClick={() => resetTemplate(index)}
                                                                    className="capitalTxt"
                                                                >
                                                                    {l.cancel}
                                                                </Button>
                                                            </div>
                                                        )}
                                                        {!editingIndices.includes(index) ? (
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                className="whiteTxt capitalTxt"
                                                                onClick={() => handleEditToggle(index)}
                                                            >
                                                                {l.edit}
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                className="whiteTxt capitalTxt"
                                                                onClick={() => saveTemplate(item, index)}
                                                            >
                                                                {l.save}
                                                            </Button>
                                                        )}
                                                    </div>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {additionalParameters && <AdditionalParameters handleClose={handleClose} open={additionalParameters} />}
            </div>
        </Fragment>
    );
};

export default SMSGateway;
